import { render, staticRenderFns } from "./no-results.vue?vue&type=template&id=3258078e"
import script from "./no-results.vue?vue&type=script&lang=js"
export * from "./no-results.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3258078e')) {
      api.createRecord('3258078e', component.options)
    } else {
      api.reload('3258078e', component.options)
    }
    module.hot.accept("./no-results.vue?vue&type=template&id=3258078e", function () {
      api.rerender('3258078e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/general/no-results.vue"
export default component.exports